// announcement bar
$(".announce_slider").owlCarousel({
  items: 1,
  loop: true,
  nav: false,
  dots: false,
  autoplay:true,
  autoplayTimeout:8000
});

// Announcement bar: fit text to one line and keep header flush below.
// Text font-size is scaled to fill the banner-message container width while
// never wrapping, and never below MIN_FONT_SIZE.
(function () {
  var MIN_FONT_SIZE = 4;

  function getBaseFontSize(bar) {
    if (!bar) return 14;
    var cs = getComputedStyle(bar);
    var raw = cs.getPropertyValue('--topbar-font-size');
    var val = parseFloat(raw);
    if (!isNaN(val) && val > 0) return val;
    var fs = parseFloat(cs.fontSize);
    return !isNaN(fs) && fs > 0 ? fs : 14;
  }

  function getInnerWidth(el) {
    if (!el) return 0;
    var cs = getComputedStyle(el);
    var padL = parseFloat(cs.paddingLeft) || 0;
    var padR = parseFloat(cs.paddingRight) || 0;
    return Math.max(0, el.clientWidth - padL - padR);
  }

  // Measure the actual laid-out width of an element's content using the Range
  // API. This returns the natural (nowrap) width even when the element's
  // ancestors have overflow: hidden, and uses the real font metrics of the
  // source element so there is no discrepancy vs. an off-screen mirror.
  function measureContentWidth(el) {
    if (!el) return 0;
    var range = document.createRange();
    try {
      range.selectNodeContents(el);
      var rect = range.getBoundingClientRect();
      return rect.width || 0;
    } finally {
      range.detach && range.detach();
    }
  }

  function setFontSizeImportant(el, sizePx) {
    // The section's own style block sets `.announcement__bar-section p` font
    // size with !important, so we must match that priority to override it.
    el.style.setProperty('font-size', sizePx + 'px', 'important');
    el.style.setProperty('white-space', 'nowrap', 'important');
  }

  function fitAnnouncementText() {
    var bar = document.querySelector('.announcement__bar-section');
    if (!bar) return;

    var baseFont = getBaseFontSize(bar);

    // Available width is the actual banner-message content width so text can
    // grow to fill the entire visible space of the message container.
    var bannerMessage = bar.querySelector('#banner-message');
    var available = getInnerWidth(bannerMessage);
    if (available <= 0) return;

    var rteNodes = bar.querySelectorAll('.rte');
    rteNodes.forEach(function (rte) {
      var text = rte.querySelector('p') || rte;

      // Set to base and measure natural width in place using the real element.
      setFontSizeImportant(text, baseFont);
      var naturalWidth = measureContentWidth(text);
      if (!(naturalWidth > 0)) return;

      if (naturalWidth > available) {
        // Initial scale with a safety factor to absorb subpixel rounding.
        var scaledSize = baseFont * (available / naturalWidth) * 0.97;
        var newSize = Math.max(MIN_FONT_SIZE, Math.floor(scaledSize * 100) / 100);
        setFontSizeImportant(text, newSize);

        // Verify and step down further if the text still doesn't fit. This
        // covers font-metric edge cases (e.g. subpixel widths, italic tails,
        // trailing bold characters) where the initial scale is slightly off.
        var actual = measureContentWidth(text);
        var attempts = 0;
        while (actual > available && newSize > MIN_FONT_SIZE && attempts < 40) {
          newSize = Math.max(MIN_FONT_SIZE, Math.round((newSize - 0.1) * 100) / 100);
          setFontSizeImportant(text, newSize);
          actual = measureContentWidth(text);
          attempts++;
        }
      }
    });
  }

  function updateStickyOffsets() {
    var bar = document.getElementById('shopify-section-announcement-bar');
    var header = document.getElementById('shopify-section-header');
    var root = document.documentElement;
    if (bar) {
      var barHeight = bar.getBoundingClientRect().height;
      if (barHeight > 0) {
        root.style.setProperty('--announcement-bar-height', barHeight + 'px');
      }
    }
    if (header) {
      var headerHeight = header.getBoundingClientRect().height;
      if (headerHeight > 0) {
        root.style.setProperty('--header-height', headerHeight + 'px');
      }
    }
  }

  function refresh() {
    fitAnnouncementText();
    // Measure after fit so bar height reflects the final text size.
    updateStickyOffsets();
  }

  function scheduleRefresh() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(refresh);
    } else {
      setTimeout(refresh, 16);
    }
  }

  $(document).ready(function () {
    refresh();
    // Rerun after fonts load in case metrics shift.
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(scheduleRefresh);
    }
    // Rerun after each carousel slide change (different messages, different widths).
    $('.announce_slider').on('translated.owl.carousel initialized.owl.carousel resized.owl.carousel', scheduleRefresh);
  });

  $(window).on('load', scheduleRefresh);

  var resizeTimer;
  $(window).on('resize orientationchange', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refresh, 100);
  });

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(scheduleRefresh);
    var barEl = document.getElementById('shopify-section-announcement-bar');
    var headerEl = document.getElementById('shopify-section-header');
    if (barEl) ro.observe(barEl);
    if (headerEl) ro.observe(headerEl);
  }
})();

// Hide announcement bar + header when scrolling down, reveal when scrolling up.
(function () {
  var root = document.documentElement;
  var header = document.getElementById('shopify-section-header');
  if (!header) return;

  var DELTA = 5;         // Ignore tiny scroll jitters.
  var SHOW_AT_TOP = 80;  // Always show the header near the top of the page.

  var lastScrollY = window.pageYOffset || root.scrollTop || 0;
  var ticking = false;

  function hideHeader() {
    root.classList.add('header-hidden');
  }

  function showHeader() {
    root.classList.remove('header-hidden');
  }

  function onScroll() {
    var currentY = window.pageYOffset || root.scrollTop || 0;

    // Near the top: always visible.
    if (currentY <= SHOW_AT_TOP) {
      showHeader();
      lastScrollY = currentY;
      ticking = false;
      return;
    }

    // Ignore very small movements to avoid flicker.
    if (Math.abs(currentY - lastScrollY) < DELTA) {
      ticking = false;
      return;
    }

    if (currentY > lastScrollY) {
      hideHeader(); // Scrolling down.
    } else {
      showHeader(); // Scrolling up.
    }

    lastScrollY = currentY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(onScroll);
      } else {
        onScroll();
      }
      ticking = true;
    }
  }, { passive: true });
})();

// top slider
$(".slider_carousel").owlCarousel({
  items: 1,
  loop: false,
  nav: false,
  dots: false,
  autoplay:true,
  autoplayTimeout:8000 
});

$("#accessories-product").owlCarousel({
  items: 4,
  loop: true,
  nav: false,
  dots: false,
  margin: 15,
  autoplayTimeout:4500,
  smartSpeed:1000,
  responsive:{
      0:{
          items:1,
          margin: 10,
          stagePadding:50
      },
      400:{
          items:1,
          stagePadding:90
      },
      451:{
        items:2,
        stagePadding:70
      },
      576:{
        items:3,
        stagePadding:0
      },
      992:{
          items:4
      }
  }
});

// $("#collection-slider").owlCarousel({
//   items: 3,
//   loop: true,
//   nav: true,
//   dots: false,
//   autoplay:true,
//   autoplayTimeout:8000,
//   autoplayHoverPause:true,
//   smartSpeed:1000,
//   navText: ['<svg width="24" height="43" viewBox="0 0 24 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.021 1.99084L1.021 21.9908L22.021 41.9908" stroke="#414042" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="24" height="43" viewBox="0 0 24 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.021 1.99084L22.021 21.9908L1.021 41.9908" stroke="#414042" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
//   responsive:{
//       0:{
//           items:1,
//           stagePadding:40
//       },
//       451:{
//         items:1,
//         nav: false,
//         stagePadding:70
//       },
//       576:{
//         items:2,
//         nav: true,
//         stagePadding:0
//       },
//       992:{
//           items:3
//       }
//   }
// });

$("#product-slider-wrapper").owlCarousel({
  items: 2,
  loop: true,
  nav: true,
  dots: false,
  autoplay:true,
  navText: ['<svg width="80" height="72" viewBox="0 0 80 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.5909 0.841933L0.480467 35.9523L35.5909 71.0627L45.8243 60.8293L28.1027 43.1909L79.5203 43.1909L79.5203 28.7144L28.1027 28.7144L45.8243 11.076L35.5909 0.841933Z" fill="#D1BAA9"/></svg>','<svg width="80" height="72" viewBox="0 0 80 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.4091 71.1578L79.5195 36.0474L44.4091 0.93701L34.1757 11.1705L51.8973 28.8089L0.479674 28.8089L0.479673 43.2854L51.8973 43.2854L34.1757 60.9238L44.4091 71.1578Z" fill="#D1BAA9"/></svg>'],
  autoplayTimeout:5000,
  smartSpeed:1000,
  responsive:{
      0:{
          items:1
      },
      400:{
        items:2
      }
  }
});

$("#product_recommendations_slider").owlCarousel({
  items: 4,
  loop: true,
  nav: false,
  dots: false,
  margin: 30,
  autoplay:true,
  autoplayTimeout:5000,
  smartSpeed:1000,
  responsive:{
      0:{
        items:1,
        stagePadding:40
      },
      400:{
        items:1,
        stagePadding:70
      },
      451:{
        items:2,
        stagePadding:0
      },
      768:{
        items:3
      },
      1200:{
        items:4
      }
  }
});


$("#collection-featured-slider").owlCarousel({
  items: 4,
  loop: true,
  dots: false,
  autoplay:false,
  autoplayTimeout:3500,
  smartSpeed:1000,
  autoplay:false,
  autoplayHoverPause:true,
  navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="22.708" height="40" viewBox="0 0 22.708 40"><path id="Path_1206" data-name="Path 1206" d="M53.5,56.763a2.713,2.713,0,0,0,1.913-4.626L40.039,36.762,55.414,21.388a2.708,2.708,0,0,0-3.827-3.834L34.292,34.849a2.707,2.707,0,0,0,0,3.827L51.587,55.97a2.688,2.688,0,0,0,1.913.792Z" transform="translate(-33.5 -16.763)" fill="#414042"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="22.708" height="40" viewBox="0 0 22.708 40"><path id="Path_1205" data-name="Path 1205" d="M36.208,56.763a2.713,2.713,0,0,1-1.913-4.626L49.669,36.762,34.295,21.388a2.708,2.708,0,0,1,3.827-3.834L55.416,34.849a2.707,2.707,0,0,1,0,3.827L38.121,55.97a2.688,2.688,0,0,1-1.913.792Z" transform="translate(-33.5 -16.763)" fill="#414042"/></svg>'],
  responsive:{
      0:{
          items:1,
          stagePadding:40
      },
      451:{
        items:1,
        stagePadding:70
      },
      576:{
        items:2,
        stagePadding: 0,
        nav:true
      },
        768:{
          items:3
      },
      992:{
          items:4
      }
  }
});



// Show the first tab by default
$('.tabify-section-wrapper .tabs-stage .container div').hide();
$('.tabify-section-wrapper .tabs-stage .container div:first').show();
$('.tabify-section-wrapper .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.tabify-section-wrapper .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabify-section-wrapper .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabify-section-wrapper .tabs-stage .container .tabify-description').hide();
  $($(this).attr('href')).show();
  $($(this).attr('href')).show().children('div').show().children('div').show();
});

// $('.hero_content a.main_btn').on('click', function(event){
//   $('html, body').animate({
//       scrollTop: $("#fetured_collection_self").offset().top
//   }, 2000);
// });


function isNumberKey(evt){
 var charCode = (evt.which) ? evt.which : evt.keyCode
 if (charCode > 31 && (charCode < 48 || charCode > 57))
   return false;
 return true;
}

// Give either the native gallery or the active StarApps clone VIM's scrollable
// thumbnail layout without changing the main slider or variant-image filtering.
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var root = document.documentElement;
  var updateScheduled = false;
  var nativeGallery = document.querySelector('.js-product-gallery:not(.starapps)');
  var hasOnlyDefaultVariant = Boolean(
    nativeGallery &&
    nativeGallery.dataset.hasOnlyDefaultVariant === 'true'
  );
  var via = window.viaData || {};
  var starAppsRestricted = via.autoActivate === 'active'
    ? via.viaStatus === 'inactive'
    : via.autoActivate === 'inactive' && via.viaStatus !== 'active';
  var starAppsExpected = !hasOnlyDefaultVariant && !starAppsRestricted && Boolean(
    window._starapps_theme_settings ||
    window.viaData ||
    document.querySelector(
      'script[src*="starapps"], ' +
      'script[src*="variant-image-swatch"], ' +
      'script[src*="/apps/via/"], ' +
      'link[href*="variant-image-swatch"]'
    )
  );
  var vimBlock = document.querySelector('.VIM-app-block');
  var vimExpected = Boolean(
    vimBlock &&
    vimBlock.dataset.vimStatus !== 'false' &&
    /\d/.test(vimBlock.dataset.vimMetaProduct || '')
  );
  var allowNativeFallback = !starAppsExpected;
  var nativeFallbackTimer = null;

  function markFilteredGalleryReady() {
    allowNativeFallback = false;

    if (nativeFallbackTimer) {
      window.clearTimeout(nativeFallbackTimer);
      nativeFallbackTimer = null;
    }

    root.classList.add('product-gallery-filtered');
    root.classList.remove('product-gallery-pending');
  }

  function enableNativeFallback() {
    if (document.querySelector('.js-product-gallery.starapps')) {
      markFilteredGalleryReady();
      scheduleGalleryUpdate();
      return;
    }

    allowNativeFallback = true;
    root.classList.remove('product-gallery-filtered');
    root.classList.remove('product-gallery-pending');
    scheduleGalleryUpdate();
  }

  // VIM only builds its slider when it finds a visible product photo in the
  // gallery, so the loading preview stays up until VIM swaps its slider in.
  function waitForVimGallery() {
    var gallery = nativeGallery;
    var observer = new MutationObserver(check);
    var timer = window.setTimeout(finish, 8000);

    function finish() {
      observer.disconnect();
      window.clearTimeout(timer);

      if (document.querySelector('.VIM-media-wrapper')) {
        root.classList.remove('product-gallery-pending');
      } else {
        enableNativeFallback();
      }
    }

    function check() {
      if (
        document.querySelector('.VIM-media-wrapper') ||
        document.body.classList.contains('VIM-exclude')
      ) {
        finish();
      }
    }

    if (gallery) observer.observe(gallery, { childList: true });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    check();
  }

  function setActiveThumbnail(gallery, wrapper, imageId) {
    if (!imageId) return;

    gallery.querySelectorAll('.js-thumb-item').forEach(function (thumbnail) {
      var isActive = thumbnail.dataset.imageId === String(imageId);

      thumbnail.classList.toggle('active-slide', isActive);
      thumbnail.classList.toggle('is-nav-selected', isActive);

      if (isActive) {
        thumbnail.setAttribute('aria-current', 'true');
        scrollActiveThumbnail(wrapper, thumbnail);
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });
  }

  function scrollActiveThumbnail(wrapper, thumbnail) {
    if (!wrapper || !thumbnail) return;

    var wrapperRect = wrapper.getBoundingClientRect();
    var thumbnailRect = thumbnail.getBoundingClientRect();
    var horizontal = window.innerWidth < 990;

    if (horizontal) {
      if (thumbnailRect.left < wrapperRect.left) {
        wrapper.scrollTo({
          left: wrapper.scrollLeft + thumbnailRect.left - wrapperRect.left,
          behavior: 'smooth'
        });
      } else if (thumbnailRect.right > wrapperRect.right) {
        wrapper.scrollTo({
          left: wrapper.scrollLeft + thumbnailRect.right - wrapperRect.right,
          behavior: 'smooth'
        });
      }
      return;
    }

    if (thumbnailRect.top < wrapperRect.top) {
      wrapper.scrollTo({
        top: wrapper.scrollTop + thumbnailRect.top - wrapperRect.top,
        behavior: 'smooth'
      });
    } else if (thumbnailRect.bottom > wrapperRect.bottom) {
      wrapper.scrollTo({
        top: wrapper.scrollTop + thumbnailRect.bottom - wrapperRect.bottom,
        behavior: 'smooth'
      });
    }
  }

  function watchActiveThumbnail(list, wrapper) {
    if (list.vimStyleObserver) return;

    list.vimStyleObserver = true;

    var activeObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('active-slide')
        ) {
          scrollActiveThumbnail(wrapper, mutation.target);
        }
      });
    });

    activeObserver.observe(list, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  function watchThumbnailInteractions(gallery, list, wrapper) {
    if (list.vimStyleInteractions) return;

    list.vimStyleInteractions = true;

    function selectThumbnail(thumbnail) {
      var thumbnails = Array.prototype.slice.call(list.querySelectorAll('.js-thumb-item'));
      var index = thumbnails.indexOf(thumbnail);
      var main = gallery.querySelector('.js-carousel-main');
      var mainCarousel = window.Flickity && main ? window.Flickity.data(main) : null;

      if (index < 0 || !mainCarousel) return;

      mainCarousel.select(index);
      setActiveThumbnail(gallery, wrapper, thumbnail.dataset.imageId);
    }

    list.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.js-thumb-item');
      if (!thumbnail || !list.contains(thumbnail)) return;

      event.preventDefault();
      selectThumbnail(thumbnail);
    });

    list.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var thumbnail = event.target.closest('.js-thumb-item');
      if (!thumbnail || !list.contains(thumbnail)) return;

      event.preventDefault();
      selectThumbnail(thumbnail);
    });
  }

  function watchMainSlider(gallery, wrapper) {
    var main = gallery.querySelector('.js-carousel-main');
    var mainCarousel = window.Flickity && main ? window.Flickity.data(main) : null;

    if (!mainCarousel || main.vimStyleCarousel === mainCarousel) return;

    main.vimStyleCarousel = mainCarousel;
    mainCarousel.on('change', function () {
      var selected = mainCarousel.selectedElement;
      setActiveThumbnail(gallery, wrapper, selected && selected.dataset.imageId);
    });
  }

  function matchVimArrowIcons(gallery) {
    gallery.querySelectorAll(
      '#slider > .js-carousel-main > .flickity-prev-next-button'
    ).forEach(function (button) {
      if (button.dataset.vimStyleIcon === 'true') return;

      button.dataset.vimStyleIcon = 'true';
      button.innerHTML = [
        '<svg class="flickity-button-icon" viewBox="0 0 15 28" fill="none" aria-hidden="true">',
        '<path d="M0.796875 1.2793L13.5169 13.9993L0.796875 26.7093"',
        ' stroke="currentColor" fill="none" stroke-miterlimit="10"></path>',
        '</svg>'
      ].join('');
    });
  }

  function watchMainGalleryImages(gallery) {
    if (!gallery.classList.contains('starapps')) return;

    gallery.querySelectorAll('img.product__image').forEach(function (image) {
      function updateReadyState() {
        image.classList.toggle('gallery-image-ready', image.complete && image.naturalWidth > 0);
      }

      if (!image.galleryImageReadinessBound) {
        image.galleryImageReadinessBound = true;
        image.addEventListener('load', updateReadyState);
        image.addEventListener('error', updateReadyState);
      }

      updateReadyState();
    });
  }

  function prepareGallery(gallery) {
    watchMainGalleryImages(gallery);

    var list = gallery.querySelector('.js-thumb-carousel-nav');
    var wrapper = gallery.querySelector('.js-thumb-carousel-scroll');

    if (!list || !wrapper) return;

    if (window.Flickity) {
      var thumbnailCarousel = window.Flickity.data(list);
      if (thumbnailCarousel) thumbnailCarousel.destroy();
    }

    list.classList.add('vim-style-thumbnail-list');
    watchActiveThumbnail(list, wrapper);
    watchThumbnailInteractions(gallery, list, wrapper);
    watchMainSlider(gallery, wrapper);
    matchVimArrowIcons(gallery);

    var activeThumbnail = list.querySelector('.active-slide');
    scrollActiveThumbnail(wrapper, activeThumbnail);

    var main = gallery.querySelector('.js-carousel-main');
    if (window.Flickity && main) {
      var mainCarousel = window.Flickity.data(main);
      if (mainCarousel) mainCarousel.resize();
    }
  }

  function prepareProductGalleries() {
    updateScheduled = false;

    var starAppsGalleries = document.querySelectorAll('.js-product-gallery.starapps');
    if (starAppsGalleries.length) markFilteredGalleryReady();

    var galleries = starAppsGalleries.length
      ? starAppsGalleries
      : (
        allowNativeFallback
          ? document.querySelectorAll('.js-product-gallery:not(.starapps)')
          : []
      );

    Array.prototype.forEach.call(galleries, prepareGallery);
  }

  function scheduleGalleryUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;
    window.requestAnimationFrame(prepareProductGalleries);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleGalleryUpdate);
  } else {
    scheduleGalleryUpdate();
  }

  var galleryObserver = new MutationObserver(function (mutations) {
    var galleryChanged = mutations.some(function (mutation) {
      if (
        mutation.target.nodeType === 1 &&
        mutation.target.closest('.js-product-gallery')
      ) {
        return true;
      }

      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return (
          node.nodeType === 1 &&
          (
            node.matches('.js-product-gallery') ||
            node.querySelector('.js-product-gallery')
          )
        );
      });
    });

    if (galleryChanged) {
      document.querySelectorAll('.js-product-gallery.starapps').forEach(watchMainGalleryImages);
      scheduleGalleryUpdate();
    }
  });

  galleryObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (starAppsExpected) {
    nativeFallbackTimer = window.setTimeout(enableNativeFallback, 8000);
  } else if (vimExpected) {
    waitForVimGallery();
  } else {
    enableNativeFallback();
  }

  window.addEventListener('resize', scheduleGalleryUpdate);
})();

// Product cards show one variant's first photo, and that same variant's second
// photo on hover. Swatch hover and image hover both use this pair.
(function () {
  var vimCache = {};
  var cardState = new WeakMap();

  function fileName(src) {
    return decodeURIComponent(String(src || '').split('/').pop().split('?')[0])
      .replace(/_\d+x(?=\.[a-z0-9]+$)/i, '');
  }

  function masterSrc(src) {
    return String(src).replace(/_\d+x(?=\.(jpg|jpeg|png|webp|gif)(\?|$))/i, '');
  }

  function sized(src, width) {
    return masterSrc(src).replace(/\.(jpg|jpeg|png|webp|gif)(\?|$)/i, '_' + width + 'x.$1$2');
  }

  function srcsetFor(src) {
    return [180, 360, 540, 720, 900, 1080].map(function (width) {
      return sized(src, width) + ' ' + width + 'w';
    }).join(', ');
  }

  var sharpCollectionCards = document.body.classList.contains('template-collection');

  function paintImage(img, src) {
    if (!img || !src) return;
    if (fileName(img.currentSrc || img.getAttribute('src')) === fileName(src) && !sharpCollectionCards) return;

    if (sharpCollectionCards) {
      var sharp = sized(src, 2000);
      if (fileName(img.currentSrc || img.getAttribute('src')) === fileName(src) && img.getAttribute('sizes') === '2000px' && img.naturalWidth >= 900) return;
      img.classList.remove('lazyload', 'lazyloading', 'lazyautosizes');
      img.classList.add('lazyloaded');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
      img.removeAttribute('data-widths');
      img.setAttribute('sizes', '2000px');
      img.setAttribute('srcset', sharp + ' 2000w');
      img.setAttribute('src', sharp);
      return;
    }

    var srcset = srcsetFor(src);
    img.setAttribute('data-src', sized(src, '{width}'));
    img.setAttribute('data-srcset', srcset);
    img.setAttribute('srcset', srcset);
    img.setAttribute('src', sized(src, 720));
  }

  function cardImages(root) {
    var reveal = root.querySelector('.reveal');
    if (!reveal) return {};

    var hidden = reveal.querySelector('.hidden img');
    var main = null;
    Array.prototype.forEach.call(reveal.querySelectorAll('img'), function (img) {
      if (!main && !img.closest('.hidden')) main = img;
    });
    return { main: main, hidden: hidden };
  }

  function positionPairs(data) {
    var pairs = {};
    var owners = {};

    data.variants.forEach(function (variant) {
      if (!variant.mediaId) return;
      (owners[variant.mediaId] = owners[variant.mediaId] || []).push(variant.id);
      pairs[variant.id] = [];
    });

    var currentIds = [];
    data.media.forEach(function (media) {
      if (owners[media.id]) {
        currentIds = owners[media.id];
        currentIds.forEach(function (id) {
          pairs[id].push(media.src);
        });
      } else if (currentIds.length) {
        currentIds.forEach(function (id) {
          pairs[id].push(media.src);
        });
      }
    });

    return pairs;
  }

  function vimPairs(data, vim) {
    var groups = Object.keys(vim.options || {});
    var idToGroup = {};
    groups.forEach(function (group) {
      Object.keys(vim.options[group] || {}).forEach(function (slug) {
        idToGroup[String(vim.options[group][slug])] = group;
      });
    });

    var labeled = data.media.map(function (media) {
      var label = vim.meta[String(media.id)] || vim.meta[media.id] || '';
      var ids = String(label).replace(/^VIM_/, '').split('_').filter(function (id) {
        return /^\d+$/.test(id);
      });
      return { src: media.src, ids: ids, label: label };
    });

    function kind(image, selected) {
      if (!image.ids.length) return null;
      if (/exclude|excluded|^VIM_x$/i.test(image.label)) return null;

      var tagged = {};
      for (var i = 0; i < image.ids.length; i++) {
        var group = idToGroup[image.ids[i]];
        if (!group) return null;
        (tagged[group] = tagged[group] || []).push(image.ids[i]);
      }

      var taggedGroups = Object.keys(tagged);
      for (var g = 0; g < taggedGroups.length; g++) {
        if (tagged[taggedGroups[g]].indexOf(selected[taggedGroups[g]]) === -1) return null;
      }

      var selectedGroups = Object.keys(selected);
      var exact = taggedGroups.length === selectedGroups.length && taggedGroups.every(function (group) {
        return tagged[group].length === 1 && tagged[group][0] === selected[group];
      });
      return exact ? 'exact' : 'loose';
    }

    var pairs = {};
    data.variants.forEach(function (variant) {
      var slug = vim.variants[String(variant.id)] || vim.variants[variant.id];
      if (!slug) return;

      var parts = String(slug).split('vrlink808');
      var selected = {};
      groups.forEach(function (group, index) {
        var value = vim.options[group] && vim.options[group][parts[index]];
        if (value) selected[group] = String(value);
      });

      var images = [];
      labeled.forEach(function (image) {
        var match = kind(image, selected);
        if (!match) return;
        if (images.indexOf(image.src) === -1) images.push(image.src);
      });
      if (images.length) pairs[variant.id] = images;
    });

    return pairs;
  }

  function pairFor(pairs, variantId) {
    var images = pairs[variantId] || pairs[String(variantId)] || [];
    if (!images.length) return null;
    return {
      first: images[0],
      second: images[1] || images[0]
    };
  }

  function restingVariant(data, pairs) {
    var featured = data.media.filter(function (media) {
      return String(media.id) === String(data.featuredMediaId);
    })[0];
    var featuredName = fileName(featured && featured.src);

    return data.variants.filter(function (variant) {
      var pair = pairFor(pairs, variant.id);
      return pair && fileName(pair.first) === featuredName;
    })[0] || null;
  }

  function variantForSwatch(data, root, hovered) {
    var selected = {};
    Array.prototype.forEach.call(root.querySelectorAll('variant-swatch-king [option-target]'), function (group) {
      var target = group.getAttribute('option-target');
      var radio = hovered && group.contains(hovered)
        ? hovered
        : group.querySelector('[role="radio"][aria-checked="true"]');
      if (radio && radio.getAttribute('orig-value')) {
        selected[target] = radio.getAttribute('orig-value');
      }
    });

    var optionIndex = { option1: 0, option2: 1, option3: 2 };
    return data.variants.find(function (variant) {
      return Object.keys(selected).every(function (target) {
        return variant.options[optionIndex[target]] === selected[target];
      });
    });
  }

  function applyPair(root, pair) {
    if (!pair) return;
    var images = cardImages(root);
    root.dataset.cardFirst = pair.first;
    root.dataset.cardSecond = pair.second;
    root.dataset.pairWriting = '1';
    paintImage(images.main, pair.first);
    paintImage(images.hidden, pair.second);
    window.setTimeout(function () {
      delete root.dataset.pairWriting;
    }, 0);
  }

  function desiredPair(root) {
    var state = cardState.get(root);
    if (!state || !state.pairs) return null;

    var radio = state.selected && root.contains(state.selected) ? state.selected : null;
    if (!radio) radio = root.querySelector('variant-swatch-king [role="radio"][aria-checked="true"]');
    var variant = radio ? variantForSwatch(state.data, root, radio) : null;
    if (!variant) variant = restingVariant(state.data, state.pairs);
    return pairFor(state.pairs, variant && variant.id);
  }

  function renderCard(root) {
    applyPair(root, desiredPair(root));
  }

  function parseAttr(html, name) {
    var pattern = new RegExp(name + "='([^']*)'|" + name + '="([^"]*)"');
    var match = html.match(pattern);
    var raw = match && (match[1] || match[2]);
    if (!raw) return null;
    return JSON.parse(raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&'));
  }

  function attrReady(html, name) {
    return new RegExp(name + "='[^']*'|" + name + '="[^"]*"').test(html);
  }

  function vimFromPage(data) {
    var block = document.querySelector('.VIM-app-block');
    if (!block || !block.dataset.vimMetaProduct || !block.dataset.vimOptions || !block.dataset.vimVariants) return null;

    try {
      var variants = JSON.parse(block.dataset.vimVariants);
      if (!data.variants[0] || !variants[String(data.variants[0].id)]) return null;
      return {
        meta: JSON.parse(block.dataset.vimMetaProduct),
        options: JSON.parse(block.dataset.vimOptions),
        variants: variants
      };
    } catch (error) {
      return null;
    }
  }

  function loadVim(data) {
    if (vimCache[data.handle]) return vimCache[data.handle];

    var onPage = vimFromPage(data);
    if (onPage) {
      vimCache[data.handle] = Promise.resolve(onPage);
      return vimCache[data.handle];
    }

    var storageKey = 'keller-card-vim:' + data.handle;
    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored) {
        vimCache[data.handle] = Promise.resolve(JSON.parse(stored));
        return vimCache[data.handle];
      }
    } catch (error) {}

    vimCache[data.handle] = fetch('/products/' + data.handle).then(function (response) {
      var reader = response.body && response.body.getReader ? response.body.getReader() : null;
      if (!reader) return response.text();

      var decoder = new TextDecoder();
      var html = '';
      function read() {
        return reader.read().then(function (result) {
          if (result.value) html += decoder.decode(result.value, { stream: !result.done });
          var ready = attrReady(html, 'data-vim-meta-product') &&
            attrReady(html, 'data-vim-options') &&
            attrReady(html, 'data-vim-variants');
          if (ready || result.done) {
            if (ready) reader.cancel();
            return html;
          }
          return read();
        });
      }
      return read();
    }).then(function (html) {
      var payload = {
        meta: parseAttr(html, 'data-vim-meta-product'),
        options: parseAttr(html, 'data-vim-options'),
        variants: parseAttr(html, 'data-vim-variants')
      };
      if (!payload.meta || !payload.options || !payload.variants) return null;
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
      } catch (error) {}
      return payload;
    }).catch(function () {
      return null;
    });

    return vimCache[data.handle];
  }

  function prepareCard(script) {
    if (script.dataset.ready === 'true') return;
    script.dataset.ready = 'true';

    var root = script.closest('.product-index') || script.closest('.ci');
    if (!root) return;

    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      return;
    }

    var state = {
      data: data,
      pairs: data.vim ? null : positionPairs(data)
    };
    cardState.set(root, state);
    if (state.pairs) renderCard(root);

    if (data.vim) {
      loadVim(data).then(function (vim) {
        state.pairs = vim ? vimPairs(data, vim) : positionPairs(data);
        if (!Object.keys(state.pairs).length) state.pairs = positionPairs(data);
        renderCard(root);
      });
    }

    if (root.dataset.pairWatch === 'true') return;
    root.dataset.pairWatch = 'true';
    var observer = new MutationObserver(function () {
      if (root.dataset.pairWriting === '1') return;
      var pair = desiredPair(root);
      if (!pair) return;
      var images = cardImages(root);
      var mainMatches = !images.main || fileName(images.main.currentSrc || images.main.getAttribute('src')) === fileName(pair.first);
      var hiddenMatches = !images.hidden || fileName(images.hidden.currentSrc || images.hidden.getAttribute('src')) === fileName(pair.second);
      if (!mainMatches || !hiddenMatches) applyPair(root, pair);
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: ['src', 'srcset'],
      subtree: true
    });
  }

  function bootCards() {
    Array.prototype.forEach.call(document.querySelectorAll('.js-card-image-pairs'), prepareCard);
  }

  document.addEventListener('click', function (event) {
    var radio = event.target.closest && event.target.closest('variant-swatch-king [role="radio"]');
    if (!radio) return;
    var root = radio.closest('.product-index') || radio.closest('.ci');
    var state = root && cardState.get(root);
    if (!state) return;

    var group = radio.closest('[option-target]') || radio.parentElement;
    Array.prototype.forEach.call(group.querySelectorAll('[role="radio"]'), function (item) {
      var chosen = item === radio;
      item.setAttribute('aria-checked', chosen ? 'true' : 'false');
      var inner = item.querySelector('[swatch-option]');
      if (inner) inner.classList.toggle('swatch-selected', chosen);
    });

    state.selected = radio;
    renderCard(root);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCards);
  } else {
    bootCards();
  }

  new MutationObserver(bootCards).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  var vimBlock = document.querySelector('.VIM-app-block');
  var vimActive = Boolean(
    vimBlock &&
    vimBlock.dataset.vimStatus !== 'false' &&
    /\d/.test(vimBlock.dataset.vimMetaProduct || '')
  );
  var vimGallerySync = 0;
  var vimSyncPending = false;

  // While a variant switch swaps the gallery, a copy of the outgoing photos sits
  // inside the gallery's own (sticky) container, so it scrolls with the gallery,
  // and is clipped to the main image and thumbnail strip. It lifts once the new
  // selection's photos have loaded.
  var galleryHold = null;
  var HOLD_THEME_SETTLE_MS = 500;
  var HOLD_STARAPPS_SETTLE_MS = 1500;
  var HOLD_VIM_SETTLE_MS = 900;
  var HOLD_UNCHANGED_MS = 1500;
  var HOLD_THUMBS_MS = 1500;
  var HOLD_STABLE_MS = 150;
  var HOLD_MAX_MS = 4000;

  function isShown(el) {
    if (!el || !el.isConnected) return false;
    var style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  function activeGallery() {
    var vim = document.querySelector('.template-product .VIM-media-wrapper');
    if (vim && isShown(vim)) {
      var slider = vim.querySelector('.VIM-gallery');
      return {
        kind: 'vim',
        gallery: vim,
        host: vim,
        mainViewport: slider,
        main: vim.querySelector('.VIM-gallery .VIM-slide-item.active'),
        decorations: '.VIM-slide-zoom',
        controls: vim.querySelectorAll('.VIM-slider-button, .VIM-slider-dots'),
        thumbViewport: vim.querySelector('.VIM-thumbnail'),
        thumbs: vim.querySelectorAll('.VIM-thumbnail-item')
      };
    }

    var galleries = document.querySelectorAll('.template-product .js-product-gallery');
    for (var i = 0; i < galleries.length; i++) {
      var gallery = galleries[i];
      var carousel = gallery.querySelector('.js-carousel-main');
      if (!carousel || !isShown(gallery)) continue;

      var main = carousel.querySelector('.carousel-cell.is-selected');
      if (!main) {
        main = Array.prototype.filter.call(carousel.querySelectorAll('.carousel-cell'), isShown)[0] || null;
      }

      return {
        kind: gallery.classList.contains('starapps') ? 'starapps' : 'native',
        gallery: gallery,
        host: gallery.querySelector('.product__gallery--container') || gallery,
        mainViewport: carousel.querySelector('.flickity-viewport') || carousel,
        main: main,
        decorations: '.zoom_btn, .card-badge, .card-gift-note',
        controls: carousel.querySelectorAll(':scope > .flickity-button, :scope > .flickity-page-dots'),
        thumbViewport: gallery.querySelector('.js-thumb-carousel-scroll'),
        thumbs: gallery.querySelectorAll('.js-thumb-item')
      };
    }

    return null;
  }

  function selectedImage(view) {
    return view && view.main ? view.main.querySelector('img') : null;
  }

  function visibleThumbs(view) {
    if (!view.thumbViewport || !isShown(view.thumbViewport)) return [];
    var clip = view.thumbViewport.getBoundingClientRect();

    return Array.prototype.filter.call(view.thumbs, function (item) {
      if (item.classList.contains('keller-pair-hidden')) return false;
      var style = getComputedStyle(item);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      var rect = item.getBoundingClientRect();
      return rect.width > 2 && rect.height > 2 &&
        rect.right > clip.left + 1 && rect.left < clip.right - 1 &&
        rect.bottom > clip.top + 1 && rect.top < clip.bottom - 1;
    });
  }

  function imageLoaded(img) {
    if (!img || img.getAttribute('data-keller-src')) return false;
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0) return false;
    return img.complete && img.naturalWidth > 1;
  }

  function vimSignature() {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('.template-product .VIM-gallery .VIM-slide-item'), function (item) {
      if (item.classList.contains('keller-pair-hidden') || getComputedStyle(item).display === 'none') return;
      ids.push(item.dataset.id || fileName(liveSrc(item.querySelector('img'))));
    });
    return ids.join('|');
  }

  function currentVariantId() {
    var input = document.querySelector('.product__section [name="id"]');
    return input ? String(input.value) : '';
  }

  function placeCopy(el, rect, origin) {
    el.style.setProperty('position', 'absolute', 'important');
    el.style.setProperty('left', rect.left - origin.left + 'px', 'important');
    el.style.setProperty('top', rect.top - origin.top + 'px', 'important');
    el.style.setProperty('width', rect.width + 'px', 'important');
    el.style.setProperty('height', rect.height + 'px', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('transform', 'none', 'important');
  }

  function holdClip(parent, viewport, origin, className) {
    var rect = viewport.getBoundingClientRect();
    var clip = document.createElement('div');
    clip.className = 'keller-gallery-hold__clip' + (className ? ' ' + className : '');
    placeCopy(clip, rect, origin);
    parent.appendChild(clip);
    return { el: clip, origin: { left: rect.left, top: rect.top } };
  }

  function copyImage(clip, img) {
    if (!imageLoaded(img)) return;
    var rect = img.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return;
    var style = getComputedStyle(img);
    var copy = document.createElement('img');
    copy.alt = '';
    copy.style.backgroundColor = style.backgroundColor;
    copy.style.objectFit = style.objectFit;
    copy.style.objectPosition = style.objectPosition;
    placeCopy(copy, rect, clip.origin);
    clip.el.appendChild(copy);
    copy.src = img.currentSrc || img.getAttribute('src');
  }

  function copyFrame(clip, item) {
    var style = getComputedStyle(item);
    var frame = document.createElement('div');
    frame.style.backgroundColor = style.backgroundColor;
    frame.style.borderColor = style.borderColor;
    frame.style.borderRadius = style.borderRadius;
    frame.style.borderStyle = style.borderStyle;
    frame.style.borderWidth = style.borderWidth;
    frame.style.boxSizing = 'border-box';
    placeCopy(frame, item.getBoundingClientRect(), clip.origin);
    clip.el.appendChild(frame);
  }

  // Zoom buttons, badges and arrows are styled through gallery selectors such as
  // #slider, which no longer match once copied, so they carry their computed look.
  var FROZEN_STYLES = [
    'align-items', 'background-color', 'background-image', 'border-bottom-color', 'border-bottom-left-radius',
    'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-left-color',
    'border-left-style', 'border-left-width', 'border-right-color', 'border-right-style', 'border-right-width',
    'border-top-color', 'border-top-left-radius', 'border-top-right-radius', 'border-top-style',
    'border-top-width', 'bottom', 'box-shadow', 'box-sizing', 'color', 'display', 'fill', 'flex-direction',
    'font-family', 'font-size', 'font-style', 'font-weight', 'height', 'justify-content', 'left',
    'letter-spacing', 'line-height', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top', 'opacity',
    'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'position', 'right', 'stroke',
    'stroke-width', 'text-align', 'text-transform', 'top', 'transform', 'visibility', 'white-space', 'width',
    'z-index'
  ];

  function freezeStyles(source, copy) {
    var style = getComputedStyle(source);
    FROZEN_STYLES.forEach(function (name) {
      var value = style.getPropertyValue(name);
      if (value) copy.style.setProperty(name, value, 'important');
    });
    for (var i = 0; i < source.children.length && i < copy.children.length; i++) {
      freezeStyles(source.children[i], copy.children[i]);
    }
  }

  function copyDecoration(clip, el) {
    if (!isShown(el)) return;
    var copy = el.cloneNode(true);
    copy.removeAttribute('id');
    Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (node) {
      node.removeAttribute('id');
    });
    freezeStyles(el, copy);
    placeCopy(copy, el.getBoundingClientRect(), clip.origin);
    clip.el.appendChild(copy);
  }

  function buildHoldOverlay(view) {
    var host = view.host;
    var hostRect = host.getBoundingClientRect();
    var overlay = document.createElement('div');
    var frame = {
      el: overlay,
      origin: { left: hostRect.left + host.clientLeft, top: hostRect.top + host.clientTop }
    };

    overlay.className = 'keller-gallery-hold';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.width = host.clientWidth + 'px';
    overlay.style.height = host.clientHeight + 'px';

    if (view.mainViewport && isShown(view.mainViewport)) {
      var main = holdClip(overlay, view.mainViewport, frame.origin, view.kind === 'vim' ? '' : 'product-media-container');
      if (view.main) {
        copyImage(main, selectedImage(view));
        Array.prototype.forEach.call(view.main.querySelectorAll(view.decorations), function (el) {
          copyDecoration(main, el);
        });
      }
    }

    Array.prototype.forEach.call(view.controls, function (el) {
      copyDecoration(frame, el);
    });

    if (view.thumbViewport && isShown(view.thumbViewport)) {
      var strip = holdClip(overlay, view.thumbViewport, frame.origin);
      visibleThumbs(view).forEach(function (item) {
        copyFrame(strip, item);
        copyImage(strip, item.querySelector('img'));
        Array.prototype.forEach.call(item.querySelectorAll('.thumbnail-icon'), function (el) {
          copyDecoration(strip, el);
        });
      });
    }

    return overlay;
  }

  function restoreHoldHost(hold) {
    if (!hold.host || !hold.hostStyle) return;
    hold.host.style.position = hold.hostStyle.position;
    hold.host.style.minHeight = hold.hostStyle.minHeight;
    hold.hostStyle = null;
  }

  function adoptHoldHost(hold, host) {
    if (hold.host !== host) {
      restoreHoldHost(hold);
      hold.host = host;
      hold.hostStyle = { position: host.style.position, minHeight: host.style.minHeight };
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.style.minHeight = hold.height + 'px';
    }
    if (hold.overlay.parentNode !== host) host.appendChild(hold.overlay);
  }

  function unveilView(view) {
    if (!window.lazySizes || !window.lazySizes.loader) return;
    var images = [selectedImage(view)];
    visibleThumbs(view).forEach(function (item) {
      images.push(item.querySelector('img'));
    });
    images.forEach(function (img) {
      if (img && img.classList.contains('lazyload')) window.lazySizes.loader.unveil(img);
    });
  }

  function markHoldChanged(hold, view) {
    if (hold.changed) return;
    hold.changed = true;
    hold.changedAt = Date.now();
    unveilView(view);
  }

  function releaseGalleryHold() {
    var hold = galleryHold;
    if (!hold) return;

    galleryHold = null;
    window.clearInterval(hold.poll);
    window.clearTimeout(hold.maxTimer);
    document.removeEventListener('load', checkGalleryHold, true);
    if (hold.observer) hold.observer.disconnect();

    window.requestAnimationFrame(function () {
      hold.overlay.classList.add('is-finished');
      window.setTimeout(function () {
        hold.overlay.remove();
        restoreHoldHost(hold);
        if (!galleryHold) document.documentElement.classList.remove('keller-gallery-holding');
      }, 200);
    });
  }

  function checkGalleryHold() {
    var hold = galleryHold;
    if (!hold) return;

    var view = activeGallery();
    if (!view || view.kind !== hold.kind) {
      releaseGalleryHold();
      return;
    }
    if (hold.overlay.parentNode !== view.host) adoptHoldHost(hold, view.host);

    var now = Date.now();
    var variantId = currentVariantId();
    if (variantId !== hold.variantId) {
      hold.variantId = variantId;
      hold.variantChangedAt = now;
    }

    if (!hold.changed) {
      var changed = view.kind === 'vim'
        ? !vimSyncPending && vimSignature() !== hold.signature
        : view.gallery !== hold.gallery || view.main !== hold.main;
      if (changed) markHoldChanged(hold, view);
    }

    var settleMs = view.kind === 'vim' ? HOLD_VIM_SETTLE_MS
      : view.kind === 'starapps' ? HOLD_STARAPPS_SETTLE_MS
      : HOLD_THEME_SETTLE_MS;
    var settled = hold.variantChangedAt
      ? now - hold.variantChangedAt > settleMs
      : now - hold.startedAt > HOLD_UNCHANGED_MS;
    if (!hold.changed && !settled) return;
    if (view.kind === 'vim' && vimSyncPending) return;

    // VIM filters the slides and moves its active slide in separate steps.
    var image = selectedImage(view);
    var shape = (view.kind === 'vim' ? vimSignature() : '') + '>' + liveSrc(image);
    if (shape !== hold.shape) {
      hold.shape = shape;
      hold.shapeAt = now;
    }
    if (now - hold.shapeAt < HOLD_STABLE_MS) return;
    if (image && !imageLoaded(image)) return;

    var thumbsWaiting = visibleThumbs(view).some(function (item) {
      var img = item.querySelector('img');
      return img && !imageLoaded(img);
    });
    if (thumbsWaiting && now - (hold.changedAt || hold.startedAt) < HOLD_THUMBS_MS) return;

    releaseGalleryHold();
  }

  function baseGalleryHold(hold, view) {
    hold.gallery = view.gallery;
    hold.main = view.main;
    hold.signature = view.kind === 'vim' ? vimSignature() : '';
    hold.variantId = currentVariantId();
    hold.variantChangedAt = 0;
    hold.changed = false;
    hold.changedAt = 0;
    hold.shape = null;
    hold.shapeAt = 0;
    hold.startedAt = Date.now();
    window.clearTimeout(hold.maxTimer);
    hold.maxTimer = window.setTimeout(releaseGalleryHold, HOLD_MAX_MS);
  }

  // StarApps removes the gallery and inserts a rebuilt copy on every switch.
  // Moving the overlay over from a mutation callback lands before the next paint.
  function watchGalleryReplacement(hold) {
    var parent = hold.gallery.parentElement;
    if (!parent) return;

    hold.observer = new MutationObserver(function () {
      if (galleryHold !== hold) return;
      var view = activeGallery();
      if (!view || view.gallery === hold.gallery) return;
      adoptHoldHost(hold, view.host);
      hold.gallery = view.gallery;
      markHoldChanged(hold, view);
    });
    hold.observer.observe(parent, { childList: true });
  }

  function startGalleryHold(rebase) {
    if (galleryHold) {
      if (rebase) {
        var current = activeGallery();
        if (current) baseGalleryHold(galleryHold, current);
      }
      return;
    }

    var view = activeGallery();
    if (!view) return;

    var hold = {
      kind: view.kind,
      overlay: buildHoldOverlay(view),
      height: view.host.clientHeight,
      host: null,
      hostStyle: null
    };

    adoptHoldHost(hold, view.host);
    baseGalleryHold(hold, view);
    if (view.kind === 'starapps') watchGalleryReplacement(hold);

    document.documentElement.classList.add('keller-gallery-holding');
    galleryHold = hold;
    hold.poll = window.setInterval(checkGalleryHold, 60);
    document.addEventListener('load', checkGalleryHold, true);
  }

  var HELD_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function liveSrc(img) {
    if (!img) return '';
    var src = img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0) return img.getAttribute('data-keller-src') || '';
    return src;
  }

  function holdImage(img) {
    if (!img) return;
    var src = img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0) return;
    if (!img.getAttribute('data-keller-src')) img.setAttribute('data-keller-src', src);
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      if (!img.getAttribute('data-keller-srcset')) img.setAttribute('data-keller-srcset', srcset);
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', HELD_SRC);
  }

  function releaseImage(img) {
    if (!img) return;
    var src = img.getAttribute('data-keller-src');
    if (!src) return;
    var srcset = img.getAttribute('data-keller-srcset') || '';
    img.removeAttribute('data-keller-src');
    img.removeAttribute('data-keller-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
  }

  function vimContext() {
    var block = document.querySelector('.VIM-app-block');
    if (!block || !block.dataset.vimOptions || !block.dataset.vimVariants) return null;

    var options, variantMap;
    try {
      options = JSON.parse(block.dataset.vimOptions);
      variantMap = JSON.parse(block.dataset.vimVariants);
    } catch (error) {
      return null;
    }

    var input = document.querySelector('.product__section [name="id"]');
    var variantId = (input && input.value) || block.dataset.vimSelectedVariantId;
    var slug = variantMap[String(variantId)];
    if (!slug) return null;

    var groups = Object.keys(options);
    var idToGroup = {};
    groups.forEach(function (group) {
      Object.keys(options[group] || {}).forEach(function (key) {
        idToGroup[String(options[group][key])] = group;
      });
    });

    var parts = String(slug).split('vrlink808');
    var selected = {};
    groups.forEach(function (group, index) {
      var value = options[group] && options[group][parts[index]];
      if (value) selected[group] = String(value);
    });

    var colorGroup = groups.filter(function (group) {
      return /color/i.test(group);
    })[0] || groups[0];

    return {
      options: options,
      idToGroup: idToGroup,
      selected: selected,
      colorGroup: colorGroup,
      colorId: selected[colorGroup] || ''
    };
  }

  function labelColorIds(label, ctx) {
    return String(label || '').replace(/^VIM_/, '').split('_').filter(function (id) {
      return /^\d+$/.test(id) && ctx.idToGroup[id] === ctx.colorGroup;
    });
  }

  function wantsColor(label, ctx, colorId) {
    if (!label || /exclude|excluded|^VIM_x$/i.test(label)) return false;
    var colors = labelColorIds(label, ctx);
    return colors.length > 0 && colors.indexOf(String(colorId)) !== -1;
  }

  function eachVimItem(fn) {
    Array.prototype.forEach.call(document.querySelectorAll('.VIM-slide-item, .VIM-thumbnail-item'), fn);
  }

  function applyColorDownloads() {
    var ctx = vimContext();
    if (!ctx || !ctx.colorId) return;
    eachVimItem(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      if (wantsColor(item.dataset.alt || '', ctx, ctx.colorId)) releaseImage(img);
      else holdImage(img);
    });
  }

  function prefetchColor(colorId) {
    var ctx = vimContext();
    if (!ctx || !colorId) return;
    eachVimItem(function (item) {
      if (!wantsColor(item.dataset.alt || '', ctx, colorId)) return;
      releaseImage(item.querySelector('img'));
    });
  }

  function sameFile(a, b) {
    var left = fileName(a);
    return !!left && left === fileName(b);
  }

  function shouldSkipPreload(url) {
    if (!url) return false;
    var held = document.querySelectorAll('.VIM-slide-item img[data-keller-src], .VIM-thumbnail-item img[data-keller-src]');
    for (var i = 0; i < held.length; i++) {
      if (sameFile(held[i].getAttribute('data-keller-src'), url)) return true;
    }
    return false;
  }

  function installVimDownloadHook() {
    if (window.__kellerVimSrcHook) return;
    window.__kellerVimSrcHook = true;

    var nativeSetAttribute = Element.prototype.setAttribute;
    var nativeAppend = Node.prototype.appendChild;
    var pendingSrc = new WeakMap();
    var srcDescriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');

    function flushVimImage(img) {
      var pending = pendingSrc.get(img);
      if (!pending) return false;
      pendingSrc.delete(img);

      var slide = img.closest && img.closest('.VIM-slide-item, .VIM-thumbnail-item');
      var ctx = slide && vimContext();
      var keep = !slide || (ctx && wantsColor(slide.dataset.alt || '', ctx, ctx.colorId));

      if (keep) {
        if (pending.srcset) nativeSetAttribute.call(img, 'srcset', pending.srcset);
        if (pending.src) nativeSetAttribute.call(img, 'src', pending.src);
      } else {
        if (pending.src) nativeSetAttribute.call(img, 'data-keller-src', pending.src);
        if (pending.srcset) nativeSetAttribute.call(img, 'data-keller-srcset', pending.srcset);
        nativeSetAttribute.call(img, 'src', HELD_SRC);
      }
      return true;
    }

    // Images that reach the page through append, insertBefore or innerHTML never
    // pass through appendChild, so anything still pending is settled right after.
    function flushSoon(img) {
      Promise.resolve().then(function () {
        if (pendingSrc.has(img)) flushVimImage(img);
      });
    }

    Element.prototype.setAttribute = function (name, value) {
      if (this.tagName === 'IMG' && (name === 'src' || name === 'srcset') && value && String(value).indexOf('data:') !== 0) {
        var pending = pendingSrc.get(this) || {};
        pending[name] = value;
        pendingSrc.set(this, pending);
        if (!this.isConnected) {
          flushSoon(this);
          return;
        }
        if (flushVimImage(this)) return;
      }
      return nativeSetAttribute.apply(this, arguments);
    };

    Node.prototype.appendChild = function (node) {
      var result = nativeAppend.call(this, node);
      if (node && node.tagName === 'IMG') flushVimImage(node);
      return result;
    };

    if (srcDescriptor && srcDescriptor.set && srcDescriptor.get) {
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        configurable: true,
        enumerable: srcDescriptor.enumerable,
        get: function () {
          return srcDescriptor.get.call(this);
        },
        set: function (value) {
          if (!this.isConnected && shouldSkipPreload(value)) return;
          srcDescriptor.set.call(this, value);
        }
      });
    }
  }

  if (vimActive) installVimDownloadHook();

  function radioColorId(radio) {
    var ctx = vimContext();
    if (!ctx) return '';
    var id = String(radio.getAttribute('option-value-id') || '');
    if (ctx.idToGroup[id] === ctx.colorGroup) return id;
    var name = String(radio.getAttribute('orig-value') || '').toLowerCase();
    var map = ctx.options[ctx.colorGroup] || {};
    if (map[name]) return String(map[name]);
    var match = Object.keys(map).filter(function (key) {
      return key.replace(/-/g, ' ') === name;
    })[0];
    return match ? String(map[match]) : '';
  }

  function syncVimGallery() {
    var ctx = vimContext();
    var gallery = document.querySelector('.VIM-gallery');
    if (!ctx || !gallery) return;
    applyColorDownloads();

    var idToGroup = ctx.idToGroup;
    var selected = ctx.selected;

    function matchKind(label) {
      var ids = String(label || '').replace(/^VIM_/, '').split('_').filter(function (id) {
        return /^\d+$/.test(id);
      });
      if (!ids.length || /exclude|excluded|^VIM_x$/i.test(label)) return null;

      var tagged = {};
      for (var i = 0; i < ids.length; i++) {
        var group = idToGroup[ids[i]];
        if (!group) return null;
        (tagged[group] = tagged[group] || []).push(ids[i]);
      }

      var taggedGroups = Object.keys(tagged);
      for (var g = 0; g < taggedGroups.length; g++) {
        if (!selected[taggedGroups[g]] || tagged[taggedGroups[g]].indexOf(selected[taggedGroups[g]]) === -1) return null;
      }

      var exact = taggedGroups.length === Object.keys(selected).length && taggedGroups.every(function (group) {
        return tagged[group].length === 1 && tagged[group][0] === selected[group];
      });
      return exact ? 'exact' : 'loose';
    }

    var allowed = {};
    Array.prototype.forEach.call(gallery.querySelectorAll('.VIM-slide-item'), function (slide) {
      var match = matchKind(slide.dataset.alt || '');
      var name = fileName(liveSrc(slide.querySelector('img')));
      if (!name) return;
      if (match === 'exact' || match === 'loose') allowed[name] = true;
    });
    if (!Object.keys(allowed).length) return;

    Array.prototype.forEach.call(document.querySelectorAll('.keller-pair-hidden'), function (el) {
      el.classList.remove('keller-pair-hidden');
    });

    var visibleAllowed = 0;
    Array.prototype.forEach.call(gallery.querySelectorAll('.VIM-slide-item'), function (slide) {
      if (getComputedStyle(slide).display === 'none') return;
      var name = fileName(liveSrc(slide.querySelector('img')));
      if (name && allowed[name]) visibleAllowed += 1;
    });
    if (!visibleAllowed) return;

    function hideExtra(el) {
      if (getComputedStyle(el).display === 'none') return;
      var name = fileName(liveSrc(el.querySelector('img')));
      if (name && !allowed[name]) el.classList.add('keller-pair-hidden');
    }

    Array.prototype.forEach.call(gallery.querySelectorAll('.VIM-slide-item'), hideExtra);
    Array.prototype.forEach.call(document.querySelectorAll('.VIM-thumbnail-item'), hideExtra);
  }

  function scheduleVimGallery() {
    vimSyncPending = true;
    window.clearTimeout(vimGallerySync);
    vimGallerySync = window.setTimeout(function () {
      vimSyncPending = false;
      syncVimGallery();
    }, 60);
  }

  function productSwatch(target) {
    var radio = target.closest && target.closest('variant-swatch-king [role="radio"]');
    if (!radio || radio.closest('.product-index') || radio.closest('.ci')) return null;
    if (radio.getAttribute('aria-checked') === 'true') return null;
    return radio;
  }

  document.addEventListener('pointerdown', function (event) {
    if (!document.body.classList.contains('template-product')) return;
    var radio = productSwatch(event.target);
    if (!radio) return;
    var group = radio.closest('[option-name]');
    if (group && /color/i.test(group.getAttribute('option-name') || '')) prefetchColor(radioColorId(radio));
    startGalleryHold(true);
  }, true);

  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('template-product')) return;
    if (productSwatch(event.target)) startGalleryHold(true);
  }, true);

  document.addEventListener('change', function (event) {
    if (!document.body.classList.contains('template-product')) return;
    var control = event.target.closest && event.target.closest(
      '.product__section-details select, .product__section-details input[type="radio"]'
    );
    if (control) startGalleryHold(false);
  }, true);

  if (vimActive) {
    var vimObserver = new MutationObserver(function () {
      watchVimWrapper();
      applyColorDownloads();
      scheduleVimGallery();
    });
    var vimWatchRoot = null;

    // Until VIM builds its slider only new nodes matter; after that, the slider's
    // own style and image changes drive the sync.
    var watchVimWrapper = function () {
      var wrapper = document.querySelector('.VIM-media-wrapper');
      if (!wrapper || wrapper === vimWatchRoot) return;
      vimWatchRoot = wrapper;
      vimObserver.disconnect();
      vimObserver.observe(wrapper, {
        attributes: true,
        attributeFilter: ['style', 'aria-checked', 'src', 'srcset'],
        childList: true,
        subtree: true
      });
    };

    vimObserver.observe(document.body, { childList: true, subtree: true });
    watchVimWrapper();
    applyColorDownloads();
    scheduleVimGallery();
    document.addEventListener('change', scheduleVimGallery, true);
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('variant-swatch-king')) scheduleVimGallery();
    }, true);
  }
})();